import { observer } from "mobx-react-lite";
import { ContextProps } from "@menu/core/types";
import { AnalyticsType, getAnalyticTags } from "@menu/core/lib";

const SignIn = observer((props: ContextProps) => {
    const context = props.context;
    const dictionary = context.dictionary;

    if (context.config.hideProfile || context.isLoggedIn) {
        return null;
    }

    const url = context.authService.getSignInUrl();

    const analyticTags = getAnalyticTags({
        component_name: "signin_click",
        nav_item: AnalyticsType.topLevel,
        nav_text: "sign_in",
        target_page_url: url
    });

    return (<span className="sign-in"
        {...analyticTags}
        onClick={() => context.authService.signIn()}>{dictionary.signIn}</span>);
});

export default SignIn;